define('drops/button/button',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/onlongpress',
    'lq/tooltip'
], function ($, Drop, Style, util, OnLongPress, Tooltip) {
    'use strict';

    var defaults = {
        data: {
            text: 'New Button',
            useDynamicWidth: true,
            useDynamicHeight: true,
            longPressDelay: 1000,
            activeStyleDuration: 0,
            state: 'enabled',
            title: {
                option: Tooltip.hardcoded
            },
        }
    };

    function Button(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$button = $('<div/>')
            .addClass('boxToBorderSize drop-text-content')
            .attr('name', this.data.name)
            .text(this.data.text)
            .attr('tabindex', this.data.tabIndex)
            .css({
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 100%',
                width: '100%'
            });

        this.tooltip = new Tooltip(this, this.data.title, this.$button);

        // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
        this.$element
            .append($('<div />')
                .css({
                    display: 'flex',
                    whiteSpace: 'pre-wrap',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$button));

        Style.renderStyles(this, null, this.$button);

        if (this.data.state === 'enabled') {
            this.enable();
        } else {
            this.disable();
        }

        if (this.data.activeStyleDuration > 0) {
            this.$element
                .on('click', this.triggerActiveStyle.bind(this));
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
        this.applyEventTrigger('mouseLeave', 'mouseleave');
    };

    Drop.extend(Button);

    Button.typeName = 'Button';

    Button.prototype.triggerActiveStyle = function () {
        this.$button.addClass('active');

        var self = this;
        setTimeout(function () {
            self.$button.removeClass('active');
        }, this.data.activeStyleDuration);
    };

    Button.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$button);
    };

    Button.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.$button.text(this.data.text)
        this.tooltip.update();
    };

    Button.prototype.licquidMethod_enable = function() {
        this.enable();
    };

    Button.prototype.enable = function () {
        new OnLongPress().applyLongPressOnElement(this.$button, this);
        if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;
            this.$element
                .on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                    }
                });
        }

        if (!this.designData)
            this.$button
                .css({
                    cursor: 'pointer'
                })

        this.$button.removeClass('disabled');
    };

    Button.prototype.licquidMethod_disable = function() {
        this.disable();
    };

    Button.prototype.disable = function () {
        if (!this.designData)
            this.$button
                .css({
                    cursor: 'default'
                })

        this.$button.addClass('disabled');

        this.unsubscribeEventHandlers();
    };

    Button.prototype.unsubscribeEventHandlers = function () {
        this.$element.off('clicked');
        this.$element.off('keypress');
    };

    return Button;
});
